export const INDUSTRY_CODES = [
  'technology',
  'financial_services',
  'healthcare_life_sciences',
  'education',
  'retail_ecommerce',
  'manufacturing',
  'professional_services_consulting',
  'media_marketing_advertising',
  'telecommunications',
  'transportation_logistics',
  'energy_utilities',
  'government_public_sector',
  'non_profit',
  'real_estate_construction',
  'hospitality_travel',
  'legal',
  'human_resources_staffing',
  'other'
];

export const getFallbackIndustryOptions = (t) =>
  INDUSTRY_CODES.map((code) => ({
    value: code,
    label: t(`industries.${code}`, code)
  }));
